// /hooks/useBatchStore.ts
import { useDispatch, useSelector } from "react-redux";
import {
  startBatch,
  tickBatch,
  failBatch,
  finishBatch,
  cancelBatch,
  resetBatch,
  showBatch,
  selectBatch,
} from "../redux/slices/batchSlice";

// Ajusta estos types a los tuyos reales
export type ProcessOrder = {
  ticket: { id: number };
  nInterno: string;
  ordenCompra: string;
  references: any[];
  bussines_area?: { iderp?: string | number } | null;
};

type RunOptions<R = any> = {
  title?: string;
  openPdf?: "immediate" | "after-all" | "none";
  // función que emite 1 documento (tu API)
  create: (order: ProcessOrder) => Promise<R & { pdf?: string }>;
  onEachSuccess?: (order: ProcessOrder, res: R & { pdf?: string }) => void;
  onEachError?: (order: ProcessOrder, err: any) => void;
  onFinally?: () => void; // después de todo el lote
};

export const useBatchStore = () => {
  const dispatch = useDispatch();
  const batch = useSelector(selectBatch);

  const open = (total: number, title?: string) =>{
    dispatch(startBatch({ total, title }));
  }
  const tick = (p?: Partial<{ ticketId: number; pdf?: string; message?: string }>) =>
    dispatch(tickBatch(p || {}));
  const fail = (p?: Partial<{ ticketId: number; pdf?: string; message?: string }>) =>
    dispatch(failBatch(p || {}));
  const finish = () => dispatch(finishBatch());
  const cancel = () => dispatch(cancelBatch());
  const reset = () => dispatch(resetBatch());
  const show = () => dispatch(showBatch());

 
  const runBatch = async <R = any>(
    orders: ProcessOrder[],
    opts: RunOptions<R>
  ) => {
    const { title, create, openPdf = "immediate", onEachSuccess, onEachError, onFinally } = opts;
    const total = orders.length;
    const pdfQueue: string[] = [];

    dispatch(startBatch({ total, title: title ?? "Procesando documentos" }));

    try {
      for (const order of orders) {
        try {
          const res = await create(order);

          if (openPdf === "immediate" && res?.pdf) {
            window.open(res.pdf, "_blank");
          } else if (openPdf === "after-all" && res?.pdf) {
            pdfQueue.push(res.pdf);
          }

          dispatch(tickBatch({ ticketId: order.ticket.id, pdf: res?.pdf }));
          onEachSuccess?.(order, res);
        } catch (err: any) {
          dispatch(failBatch({ ticketId: order.ticket.id, message: err?.message || "Error" }));
          onEachError?.(order, err);
        }
      }

      if (openPdf === "after-all" && pdfQueue.length) {
        pdfQueue.forEach((url, i) => setTimeout(() => window.open(url, "_blank"), i * 300));
      }
    } finally {
      dispatch(finishBatch());
      onFinally?.();
    }
  };

  return {
    ...batch,
    open, tick, fail, finish, cancel, reset, show,
    runBatch,
  };
};
